/**
 * Layout-only parent route for /reports/*.
 *
 * The actual landing page lives in `_app.reports.index.tsx`. The
 * per-rep drill-down used to live alongside it but moved to
 * `/team/$userId` — Reports is the analytics view (numbers across
 * everyone), Team is the operational view (what one person is working
 * on). Clicking a row in the rep-performance table on /reports
 * navigates straight to /team/$userId.
 *
 * The role gate (manager+ only) is duplicated on each child route so
 * deep-linked navigation can't bypass it; the server enforces it too.
 */
import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

import { useAuthStore } from "../lib/auth";

export const Route = createFileRoute("/_app/reports")({
  beforeLoad: () => {
    const user = useAuthStore.getState().user;
    if (user && user.role !== "admin" && user.role !== "manager") {
      throw redirect({ to: "/deals" });
    }
  },
  component: ReportsLayout,
});

function ReportsLayout() {
  return <Outlet />;
}
